import React from 'react';
import styles from './styles.module.css';
import CloseIcon from '@mui/icons-material/Close';
import { Alert, AlertTitle, IconButton } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeContext } from 'Context/ThemeContext';

function FeatureNotAvailableDialog({ closeHandler, feature }) {
  const { theme } = useContext(ThemeContext);
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');
  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper}>
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>{tCommon('Feature not available')}</h2>
          <IconButton
            size="small"
            onClick={() => {
              closeHandler(null);
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div className={styles.changeable} style={{ margin: '10px' }}>
          <Alert severity="warning" sx={{ my: 1.25 }}>
            <AlertTitle>
              <strong>{tPopup('{{feature}} support feature not available', { feature })}</strong>
            </AlertTitle>
            {tPopup('To get {{feature}} support options, contact support team.', { feature })} -{' '}
            <strong>
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://api.whatsapp.com/send?phone=${theme.variable.phone}&text=Hey%20${theme.variable.name},%20Upgrade%20Subscription`}
              >
                {tCommon('Contact Us')}
              </a>
            </strong>
          </Alert>
        </div>
      </div>
    </div>
  );
}

export default FeatureNotAvailableDialog;
